<template>
  <product
    :productService = productService
    :transactionService = transactionService
    :locationService = locationService
  ></product>
</template>

<script>
  import Product from '@/components/Common/Rental/Products/Product'
  import productService from '@/services/licensor/product'
  import transactionService from '@/services/licensor/transaction'
  import locationService from '@/services/licensor/location'

  export default {
    components: {
      Product
    },

    data () {
      return {
        productService: productService,
        transactionService: transactionService,
        locationService: locationService,
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Licensor/Products/Product.vue